<div class="container">
  <div class="col text-center">
    <button class="btn btn-primary mb-2"
            type="button"
            (click)="filtersCollapsed = !filtersCollapsed"
            [attr.aria-expanded]="filtersCollapsed">

      <i [ngClass]="{'fas fa-caret-up': filtersCollapsed}"></i>
      <i [ngClass]="{'fas fa-caret-down': !filtersCollapsed}"></i>

      <span class="mx-2" *ngIf="filtersCollapsed">Skjul Filtre</span>
      <span class="mx-2" *ngIf="!filtersCollapsed">Vis Filtre</span>
    </button>
  </div>
</div>

<div class="collapse" [ngbCollapse]="!filtersCollapsed">
  <div class="card card-body">

    <div class="container">
      <div class="row">

        <div class="col-md-3">
          <div class="input-group my-4">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroup-orderSelect">Sortering</span>
            </div>

            <select class="form-control" id="orderSelect"
                    [(ngModel)]="filterParams.order"
                    (change)="filterChanged($event)">
              <option value="nameAsc">(A-Å)</option>
              <option value="nameDesc">(Å-A)</option>
            </select>
          </div>
        </div>       

          
        <div class="col-md-8">

          <label><strong>Tilknytning til system</strong></label>

          <div class="form-check">
            <input type="radio" name="systemFilter"
                   (change)="setHasSystem(null)"
                   [checked]="filterParams.hasSystem === null" />
            Alle
          </div>

          <div class="form-check">
            <input type="radio" name="systemFilter"
                   (change)="setHasSystem(true)"
                   [checked]="filterParams.hasSystem === true" />
            Har system
          </div>

          <div class="form-check">
            <input type="radio" name="systemFilter"
                   (change)="setHasSystem(false)"
                   [checked]="filterParams.hasSystem === false" />
            Har ikke system
          </div>

        </div>

      </div>
    </div>

  </div>
</div>
